class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.modal = null;
    this.sectionId = this.dataset.sectionId;
    this.enablePopup = this.dataset.enablePopup === 'true';
    this.delaySeconds = parseInt(this.dataset.delaySeconds || '5');
    this.frequency = this.dataset.frequency || 'once';
    this.storageKey = `newsletter-popup-${this.frequency}`;
    this.timer = null;
  }

  connectedCallback() {
    // Find the modal element - it gets moved to document.body by ModalDialog's connectedCallback
    // So we need to find it by ID in the document, not by querySelector within this element
    const modalId = 'NewsletterPopup-' + this.sectionId;
    this.modal = document.getElementById(modalId);
    
    if (!this.enablePopup) {
      console.log('[NewsletterPopup] Popup disabled, returning early');
      return;
    }

    this.init();
  }

  init() {
    // Check if popup should be shown based on frequency setting
    if (!this.shouldShowPopup()) {
      return;
    }

    // Start timer after page load
    this.timer = setTimeout(() => {
      this.showPopup();
    }, this.delaySeconds * 1000);

    // Listen for form submission to mark as completed
    const form = this.querySelector('form');
    if (form) {
      form.addEventListener('submit', () => {
        this.markAsCompleted();
      });
    }
  }

  shouldShowPopup() {
    if (this.frequency === 'always') {
      return true;
    }

    const storedValue = localStorage.getItem(this.storageKey);

    if (this.frequency === 'once') {
      return !storedValue;
    }

    if (this.frequency === 'session') {
      return !sessionStorage.getItem(this.storageKey);
    }

    return true;
  }

  showPopup() {
    if (this.modal) {
      this.modal.show();

      // Listen for modal close events to mark as dismissed
      this.modal.addEventListener('click', (event) => {
        if (event.target === this.modal) {
          this.markAsDismissed();
        }
      });

      const closeButton = this.modal.querySelector('.newsletter-popup-modal__toggle');
      if (closeButton) {
        closeButton.addEventListener('click', () => {
          this.markAsDismissed();
        });
      }
    }
  }

  markAsDismissed() {
    if (this.frequency === 'once') {
      localStorage.setItem(this.storageKey, 'dismissed');
    } else if (this.frequency === 'session') {
      sessionStorage.setItem(this.storageKey, 'dismissed');
    }
  }

  markAsCompleted() {
    if (this.frequency === 'once') {
      localStorage.setItem(this.storageKey, 'completed');
    } else if (this.frequency === 'session') {
      sessionStorage.setItem(this.storageKey, 'completed');
    }
  }

  disconnectedCallback() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }
}

customElements.define('newsletter-popup', NewsletterPopup);
